import { useTheme } from "@emotion/react";
import {
  Alert,
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";

import {
  ArrowBackIosNewOutlined,
  ArrowForwardIosOutlined,
  ClearOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import TicketModalContent from "../detailsTicketComponent";
import EditTicketComponent from "../editTicketComponent";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import ModalAlertaDuplicidade from "../modalAlertaDuplicidade";
import { getErpPrincipal } from "../../../services/erpSistema";

export default function ModalNewTicket(params) {
  const {
    open,
    handleClose = () => {},
    refrashTIckets = () => {},
    clienteErpId = null,
    serviceId = null,
    // ERP escolhido na tela (tipo e id); sem eles, a variável do front e todos
    // os clientes.
    erp: erpProp,
    erpId,
  } = params;
  const [clientes, setClientes] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loadingServicos, setLoadingServicos] = useState(false);
  const [loadingCreateTicket, setLoadingCreateTicket] = useState(false);
  const [dataTicket, setDataTicket] = useState({});
  const [dataTicketParamsFechamento, setDataTicketParamsFechamento] =
    useState(null);
  const [tipoAgendamento, setTipoAgendamento] = useState("manual");

  const [userResponsaveis, setUserResponsaveis] = useState([]);
  const [motivoFechamento, setMotivoFechamento] = useState([]);
  const [etapasFluxoAtendimento, setEtapasFluxoAtendimento] = useState([]);
  const [tipoAtendimento, setTipoAtendimento] = useState([]);
  const [origemContato, setOrigemContato] = useState([]);
  const [loadingParams, setLoadingParams] = useState(false);
  const [statusAtendimento, setStatusAtendimento] = useState([]);
  const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);
  const [tecnicosSelecionados, setTecnicosSelecionados] = useState([]);
  const [disponibilidadeSelecionada, setDisponibilidadeSelecionada] = useState(
    [],
  );
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);

  const [isEditTicket, setIsEditTicket] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [isEditOs, setIsEditOs] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  const [startDateOS, setStartDateOs] = useState(null);
  const [endDateOs, setEndDateOS] = useState(null);
  const [isNewTicket, setIsNewTicket] = useState(false);
  const [tecnicos, setTecnicos] = useState([]);
  const [tipoOs, setTipoOs] = useState([]);
  const [prioridade, setPrioridade] = useState([]);
  const [disponibilidade, setDisponibilidade] = useState([]);
  const [agenda, setAgenda] = useState([]);
  const [statusOs, setStatusOs] = useState([]);
  const [paramsAberturaOs, setParamsAberturaOs] = useState(null);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [files, setFiles] = useState([]);
  const [value, setValue] = useState(0);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [snackbar, setSnackbar] = useState(null);
  const [error, setError] = useState(false);
  const [duplicateTicketsAlert, setDuplicateTicketsAlert] = useState([]);
  const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
  const [isViewingDuplicateTicket, setIsViewingDuplicateTicket] =
    useState(false);
  const [configPermissao, setConfigPermissao] = useState(false);
  const [dataForms, setDataForms] = useState([]);
  const [forms, setForms] = useState({});
  const theme = useTheme();
  const styles = useStyles(theme);
  /*   useEffect(() => {
    if (open === true) {
      setUsuariosSelecionados(
        JSON.parse(localStorage.getItem("usuariosResponsaveis")) || [],
      );
    }
  }, [open]); */
  const erp = erpProp || getErpPrincipal();
  const phoneTicketEnable =
    window?.config?.REACT_APP_PHONE_TICKET_ENABLE ??
    process.env.REACT_APP_PHONE_TICKET_ENABLE ??
    true;
  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };
  const colors = Object.keys(theme.palette.colors)?.filter(
    (color) => color !== "white" && color !== "black",
  );
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  useEffect(() => {
    if (
      dataTicket?.clienteServicoId &&
      dataTicket?.tipoAtendimentoId &&
      !isEditTicket
    ) {
      checkDuplicidade(
        dataTicket.clienteServicoId,
        dataTicket.tipoAtendimentoId,
      );
    } else {
      setDuplicateTicketsAlert([]);
      setOpenDuplicateDialog(false);
    }
  }, [dataTicket?.clienteServicoId, dataTicket?.tipoAtendimentoId]);

  const checkDuplicidade = async (clienteServicoId, tipoAtendimentoId) => {
    try {
      const response = await api.post("/interno/find/ticketDuplicado", {
        clienteServicoId,
        tipoAtendimentoId,
        erpId,
      });
      if (response?.data?.duplicado && response?.data?.tickets?.length > 0) {
        setDuplicateTicketsAlert(response.data.tickets);
        setOpenDuplicateDialog(true);
      }
    } catch (error) {
      console.error("Erro ao verificar duplicidade de ticket:", error);
    }
  };

  const handleOpenExistingTicket = async (ticket) => {
    if (!ticket?.id_atendimento) return;
    setOpenDuplicateDialog(false);
    setIsViewingDuplicateTicket(true);
    try {
      const response = await api.post("/interno/find/tickets/id", {
        ticketId: ticket.id_atendimento,
        erpId,
      });
      if (response?.data) {
        setTicketDetails(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar detalhes do ticket:", error);
    }
  };

  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (open) {
      setUsuariosSelecionados(
        JSON.parse(localStorage.getItem("usuariosResponsaveis")) || [],
      );
      setDataTicket((prev) => ({
        ...prev,
        usuariosResponsaveis:
          JSON.parse(localStorage.getItem("usuariosResponsaveis")) || [],
      }));
      getClientes();
      getParamsNewTicket();
    }
  }, [open]);

  useEffect(() => {
    if (dataTicket?.statusAtendimentoId !== 3) {
      setDataTicketParamsFechamento(null);
    }
    if (dataTicket?.statusAtendimentoId !== 1) {
      setParamsAberturaOs(null);
      setStartDateOs(null);
      setEndDateOS(null);
      setDisponibilidadeSelecionada([]);
      setTecnicosSelecionados([]);
    }
  }, [dataTicket?.statusAtendimentoId]);

  useEffect(() => {
    if (clienteErpId) {
      const filter = clientes?.find(
        (item) => item?.clienteErpId === clienteErpId,
      );

      if (filter) {
        setDataTicket({
          ...dataTicket,
          nome: filter?.nome || null,
          cnpj: filter?.cnpj,
          clienteErpId: filter?.clienteErpId,
        });
      } else {
        setDataTicket({
          ...dataTicket,
          nome: null,
          cnpj: null,
          clienteErpId: null,
        });
      }
    }
  }, [clientes]);

  useEffect(() => {
    if (serviceId && dataTicket?.clienteErpId) {
      const filter = servicos?.find(
        (item) => item?.id_cliente_servico === serviceId,
      );

      if (filter) {
        setDataTicket({
          ...dataTicket,
          clienteServicoId: filter?.id_cliente_servico,
        });
      } else {
        setDataTicket({
          ...dataTicket,
          clienteServicoId: null,
        });
      }
    }
  }, [servicos, dataTicket?.clienteErpId, serviceId]);

  useEffect(() => {
    if (dataTicket?.cnpj) {
      getServicos();
    }
  }, [dataTicket?.cnpj]);

  useEffect(() => {
    if (dataTicket?.clienteServicoId) {
      getInfoClientNewTicket();
    }
  }, [dataTicket?.clienteServicoId]);

  const getClientes = async () => {
    try {
      const response = await api.get("/interno/getClients");
      // Grupos econômicos não podem abrir tickets — exclui das options.
      // Com ERP escolhido na tela, só os clientes dele.
      setClientes(
        Array.isArray(response?.data)
          ? response.data.filter(
              (cliente) =>
                !cliente?.isGrupoEconomico &&
                (!erpId || cliente?.erpId === erpId),
            )
          : [],
      );
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
    }
  };

  const closeModal = () => {
    if (loadingCreateTicket) return;
    handleClose();
    setDataTicket({});
    setForms({});
    setParamsAberturaOs(null);
    setUsuariosSelecionados([]);
    setTecnicosSelecionados([]);
    setDisponibilidadeSelecionada([]);

    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setIsViewingDuplicateTicket(false);

    setEndDateOS(null);
    setStartDateOs(null);
    setError(false);
    setTicketDetails(null);
    setFiles([]);
    setConfirmacaoSaidaPagina(false);
    setTipoAgendamento("manual");
    //Caso tenha ocorrido um novo ticket, atualizar os tickets ao fechar o modal
    if (isNewTicket) {
      refrashTIckets();
      setIsNewTicket(false);
    }
  };

  const handleCloseModalOrTicketView = () => {
    if (isViewingDuplicateTicket) {
      if (isEditTicket || isFinishTicket || isEditOs || isNewOs) {
        setConfirmacaoSaidaPagina(true);
      } else {
        setTicketDetails(null);
        setIsViewingDuplicateTicket(false);
        setOpenDuplicateDialog(true);
      }
      return;
    }
    if (
      isEditTicket ||
      isFinishTicket ||
      isEditOs ||
      isNewOs ||
      (open && !ticketDetails)
    ) {
      setConfirmacaoSaidaPagina(true);
    } else {
      closeModal();
    }
  };

  const handleConfirmExit = () => {
    if (isViewingDuplicateTicket) {
      setIsEditTicket(false);
      setIsFinishTicket(false);
      setIsEditOs(false);
      setIsNewOs(false);
      setTicketDetails(null);
      setIsViewingDuplicateTicket(false);
      setOpenDuplicateDialog(true);
      setConfirmacaoSaidaPagina(false);
    } else {
      closeModal();
    }
  };

  const createTicket = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.telefone ||
      !dataTicket?.tipoAtendimentoId ||
      !dataTicket?.descricaoAbertura ||
      dataTicket?.descricaoAbertura?.length < 10 ||
      (!configPermissao &&
        (!dataTicket?.statusAtendimentoId ||
          !dataTicket?.origemContatoId ||
          !usuariosSelecionados ||
          usuariosSelecionados?.length === 0)) ||
      (dataTicketParamsFechamento &&
        (!dataTicketParamsFechamento?.id_motivo_fechamento_atendimento ||
          !dataTicketParamsFechamento?.descricao_fechamento?.trim())) ||
      (dataTicket?.statusAtendimentoId === 1 &&
        (!paramsAberturaOs?.tipoOs?.id ||
          !paramsAberturaOs?.prioridade?.id_prioridade ||
          paramsAberturaOs?.disponibilidade?.length === 0 ||
          tecnicosSelecionados?.length === 0 ||
          !tecnicosSelecionados ||
          !paramsAberturaOs?.agenda?.id ||
          !paramsAberturaOs?.statusOs ||
          !paramsAberturaOs?.data_inicio_programado ||
          !paramsAberturaOs?.data_termino_programado ||
          paramsAberturaOs?.tecnicos?.length === 0 ||
          !paramsAberturaOs?.descricaoAbertura?.trim()))
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setError(false);
    setLoadingCreateTicket(true);

    const formData = new FormData();
    if (files?.length > 0) {
      const totalSize = files.reduce((total, file) => total + file?.size, 0);
      const maxSize = 20 * 1024 * 1024; // 20MB em bytes
      if (totalSize > maxSize) {
        setSnackbar({
          severity: "warning",
          children: `Tamanho total dos arquivos (${(
            totalSize /
            (1024 * 1024)
          )?.toFixed(2)}MB) excede o limite de 20MB.`,
        });
        setLoadingCreateTicket(false);
        return;
      }

      files.forEach((file) => {
        formData.append("files", file);
      });
    }
    formData.append("dataTicket", JSON.stringify(dataTicket));
    if (erpId) formData.append("erpId", erpId);

    if (Object.keys(forms)?.length > 0) {
      formData.append("forms", JSON.stringify(forms));
    }

    if (paramsAberturaOs) {
      formData.append(
        "dataOs",
        JSON.stringify({ ...paramsAberturaOs, tipoAgendamento }),
      );
    }

    if (dataTicketParamsFechamento) {
      formData.append(
        "parametros_fechamento",
        JSON.stringify(dataTicketParamsFechamento),
      );
    }
    try {
      const response = await api.post("/interno/create/ticket", formData);
      setTicketDetails(response?.data);

      setIsNewTicket(true); //Estado para monitorar se ocorreu criação de novo ticket

      // Atendimento criado, mas a OS falhou (erro devolvido pela HubSoft)
      if (response?.data?.erroOs) {
        setSnackbar({
          children: `Atendimento criado, mas a OS não foi aberta: ${response.data.erroOs}`,
          severity: "warning",
          duracao: 10000,
        });
      }
    } catch (error) {
      console.error("Erro ao criar ticket:", error);
      setSnackbar({
        children: error?.response?.data?.message || "Erro ao criar ticket",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };

  const getParamsNewTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await api.post("/interno/find/paramsNewTicket", {
        erpId,
      });
      setDataForms(response?.data?.forms || []);
      setConfigPermissao(response?.data?.configPermissao || false);
      setUserResponsaveis(response?.data?.userResponsaveis || []);
      setMotivoFechamento(response?.data?.motivoFechamento || []);
      setTipoAtendimento(response?.data?.tipoAtendimento || []);
      setOrigemContato(response?.data?.origemContato || []);
      setStatusAtendimento(response?.data?.statusAtendimento || []);
      setEtapasFluxoAtendimento(response?.data?.etapasFluxoAtendimento || []);
      setTecnicos(response?.data?.tecnicos || []);
      setTipoOs(response?.data?.tipoOs || []);
      setPrioridade(response?.data?.prioridade || []);
      setDisponibilidade(response?.data?.disponibilidade || []);
      setAgenda(response?.data?.agenda || []);
      setStatusOs(response?.data?.statusOs || []);

      setDataTicket((prev) => ({
        ...prev,
        idEtapaFluxoAtendimento:
          response?.data?.etapasFluxoAtendimento?.[0]
            ?.idEtapaFluxoAtendimento || null,
      }));
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };
  const getServicos = async () => {
    try {
      setLoadingServicos(true);
      const response = await api.post("/interno/find/allServiceClient", {
        cnpj: dataTicket?.cnpj,
        clienteId: clientes?.find(
          (item) => item?.clienteErpId === dataTicket?.clienteErpId,
        )?.id,
      });
      setServicos(response?.data);
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };
  const getInfoClientNewTicket = async () => {
    try {
      setLoadingServicos(true);
      const response = await api.post("/interno/find/infoClienteNewTicket", {
        clienteServiceId: dataTicket?.clienteServicoId,
        erpId,
      });
      setDataTicket((prev) => ({
        ...prev,
        telefone: phoneTicketEnable
          ? response?.data?.contato?.telefone || ""
          : "",
        email: response?.data?.contato?.email || "",
        enderecoInstalacao: response?.data?.endereco_instalacao || "",
      }));
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };

  const handleCloseConfirmation = () => {
    setConfirmacaoSaidaPagina(true);
  };

  return (
    <>
      {ticketDetails ? (
        <TicketModalContent
          open={open} // <- Passando o open para o Drawer interno do componente
          handleClose={handleCloseModalOrTicketView}
          erp={erp}
          erpId={erpId}
          ticketDetails={ticketDetails}
          status={ticketDetails?.status}
          labelTabsErp={labelTabsErp}
          value={value}
          handleChange={handleChange}
          isEdit={true}
          setTicketDetails={setTicketDetails}
          itensPublic={itensPublic}
          setItensPublic={setItensPublic}
          setSnackbar={setSnackbar}
          fluxoAtendimentoColor={adicionarCores(
            ticketDetails?.allEtapasFluxoAtendimentos,
          )}
          setIsEditTicket={setIsEditTicket}
          isEditTicket={isEditTicket}
          setIsFinishTicket={setIsFinishTicket}
          isFinishTicket={isFinishTicket}
          isEditOs={isEditOs}
          setIsEditOs={setIsEditOs}
          setIsNewOs={setIsNewOs}
          isNewOs={isNewOs}
        />
      ) : (
        <Drawer
          anchor="right"
          open={open}
          onClose={handleCloseConfirmation}
          PaperProps={{
            sx: {
              width: "80%",
              maxWidth: "80%",
            },
          }}
        >
          <Box sx={styles.containerModal}>
            {loadingCreateTicket ? (
              <Box sx={styles.conatinerLoading}>
                <CircularProgress />
              </Box>
            ) : (
              <Box
                sx={{
                  height: "100vh",
                  overflow: "auto",
                  padding: "0 40px",
                }}
              >
                <Box sx={styles.BoxExitModal}>
                  <IconButton onClick={handleCloseConfirmation}>
                    <ArrowForwardIosOutlined sx={{ fontSize: "20px" }} />
                  </IconButton>
                </Box>

                <Box sx={{ padding: "20px 0", mt: 3 }}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                    Criar novo ticket
                  </Typography>
                </Box>

                <EditTicketComponent
                  erp={erp}
                  erpId={erpId}
                  clientes={clientes}
                  loadingServicos={loadingServicos}
                  loadingCreateTicket={loadingCreateTicket}
                  loadingParams={loadingParams}
                  setServicos={setServicos}
                  servicos={servicos}
                  setDataTicket={setDataTicket}
                  dataTicket={dataTicket}
                  error={error}
                  statusAtendimento={statusAtendimento}
                  tipoAtendimento={tipoAtendimento}
                  origemContato={origemContato}
                  usuariosSelecionados={usuariosSelecionados}
                  setUsuariosSelecionados={setUsuariosSelecionados}
                  etapasFluxoAtendimento={etapasFluxoAtendimento}
                  userResponsaveis={userResponsaveis}
                  motivoFechamento={motivoFechamento}
                  setDataTicketParamsFechamento={setDataTicketParamsFechamento}
                  dataTicketParamsFechamento={dataTicketParamsFechamento}
                  isAddAnexo={true}
                  files={files}
                  setFiles={setFiles}
                  tecnicos={tecnicos}
                  tipoOs={tipoOs}
                  prioridade={prioridade}
                  disponibilidade={disponibilidade}
                  agenda={agenda}
                  statusOs={statusOs}
                  setParamsAberturaOs={setParamsAberturaOs}
                  paramsAberturaOs={paramsAberturaOs}
                  disponibilidadeSelecionada={disponibilidadeSelecionada}
                  setDisponibilidadeSelecionada={setDisponibilidadeSelecionada}
                  setTecnicosSelecionados={setTecnicosSelecionados}
                  tecnicosSelecionados={tecnicosSelecionados}
                  setStartDate={setStartDateOs}
                  startDate={startDateOS}
                  setEndDate={setEndDateOS}
                  endDate={endDateOs}
                  tipoAgendamento={tipoAgendamento}
                  setTipoAgendamento={setTipoAgendamento}
                  configPermissao={configPermissao}
                  dataForms={dataForms}
                  forms={forms}
                  setForms={setForms}
                />

                <Box sx={styles.containerButton}>
                  <Button
                    disabled={loadingCreateTicket}
                    onClick={handleCloseConfirmation}
                    size="small"
                  >
                    Cancelar
                  </Button>
                  <LoadingButton
                    onClick={() => createTicket()}
                    size="small"
                    loading={loadingCreateTicket}
                    variant="contained"
                  >
                    Salvar
                  </LoadingButton>
                </Box>
              </Box>
            )}
          </Box>
        </Drawer>
      )}

      {/* Componentes utilitários soltos na raiz do fragmento */}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={snackbar.duracao || 3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            {...{ ...snackbar, duracao: undefined }}
            onClose={() => setSnackbar(null)}
          />
        </Snackbar>
      )}

      <ModalAlertaDuplicidade
        open={openDuplicateDialog}
        onClose={() => {
          setOpenDuplicateDialog(false);
          setDataTicket((prev) => ({ ...prev, tipoAtendimentoId: "" }));
        }}
        onOpenTicket={(ticket) =>
          handleOpenExistingTicket(ticket || duplicateTicketsAlert[0])
        }
        onProceed={() => setOpenDuplicateDialog(false)}
        tickets={duplicateTicketsAlert}
      />

      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={handleConfirmExit}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />
    </>
  );
}
